import { render, staticRenderFns } from "./SectionInternship.vue?vue&type=template&id=aec2ba44&scoped=true&lang=pug&"
import script from "./SectionInternship.vue?vue&type=script&lang=ts&"
export * from "./SectionInternship.vue?vue&type=script&lang=ts&"
import style0 from "./SectionInternship.vue?vue&type=style&index=0&id=aec2ba44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec2ba44",
  null
  
)

/* custom blocks */
import block0 from "./SectionInternship.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./SectionInternship.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InternshipItem: require('/app/src/components/molecules/InternshipItem.vue').default,SwiperCard: require('/app/src/components/molecules/SwiperCard.vue').default})
